export default __webpack_public_path__ + "static/media/dependency-inversion.ee760e88.png";